<div class="nav" id="navbar" [class.show-menu]="isShowMenu" (mouseleave)="hideSubMenu()">
    <div class="nav-head">
       <div class="d-flex align-items-center gap-1">
        <img src="/assets/images/shivsa-logo.svg" />
        <h5 class="fw-semibold mb-0 ms-2">शिवसंकल्प</h5>
       </div>
    </div>
    <div class="accordion accordion-flush w-100" id="accordionExample">
        <ng-container *ngFor="let pages of loginPages; let i = index">
            <div class="accordion-item" routerLinkActive="active" *ngIf="(pages.PageGroup == pages.pageName)">
                <div class="accordion-header">
                    <button class="accordion-button no-sub" type="button"  [routerLink]="pages.PageURL">
                        <label for="group-{{i}}">
                            <i [innerHtml]="pages.PageIcon"></i>{{pages.pageName}}
                        </label>
                    </button>
                </div>
            </div>
            <div class="accordion-item accordion-has-submenu" routerLinkActive="active" *ngIf="(pages.PageGroup != pages.pageName)">
                <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" aria-expanded="true" aria-controls="collapseOne">
                        <label for="group-{{i}}">
                            <i [innerHtml]="pages.PageIcon"></i>{{pages.PageGroup}}
                        </label>
                    </button>
                </h2>
                <div id="collapse{{i}}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div class="accordion-body p-0">
                        <div class="list-group list-group-flush">
                            <a class="list-group-item list-group-item-action" routerLinkActive="active1" *ngFor="let page of pages.PageURL; let pageUrlIndex = index" routerLink="{{page}}">
                                <ng-container *ngFor="let pageName of pages.pageName;; let pageNameIndex = index">
                                    <ng-container *ngIf="pageNameIndex == pageUrlIndex">{{pageName}}</ng-container>
                                </ng-container>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>